import React, { useContext, Dispatch, SetStateAction, useState, useEffect } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import EmailIcon from '@material-ui/icons/Email';
import SmsIcon from '@material-ui/icons/Sms';
import Snackbar from '@material-ui/core/Snackbar';
import { MeetingContext } from '../../App';
import { axClient } from '../../axiosClient';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconButton: {
      margin: theme.spacing(1),
      color: 'white',
    },
    title: {
      margin: 0,
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(5),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    content: {
      padding: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(5),
    },
    anchorButton: {
      textDecoration: 'none',
    },
  })
);

interface ModalProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

export default function InviteModal({ showModal, setShowModal }: ModalProps) {
  const { customer, company } = useContext(MeetingContext);
  const classes = useStyles();
  let whatsapp = '';
  const mail = `mailto:${customer.customer_email}??subject=IKEA remote session invite&body=plase join remote session invite by ${company.company_name} at `;
  let sms = '';
  const [whatsappLink, setWhatsAppLink] = useState(whatsapp);
  const [smsLink, setSMSLink] = useState(sms);
  const [mailLink, SetMailLink] = useState(mail);
  const [meetingLink, setMeetingLink] = useState('');

  if (customer.customer_contact_no) {
    whatsapp = `https://wa.me/${customer.customer_contact_no.work}?text= Please%20join%20remote%20session%20by%20${company.company_name}%20at%20`;
    sms = `sms:${customer.customer_contact_no.work}?body= Please%20join%20remote%20session%20by%20${company.company_name}%20at%20`;
  }

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleClick = () => {
    navigator.clipboard.writeText(meetingLink);
    setOpen(true);
  };

  const handleSnapBarClose = (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    axClient
      .post('/auth')
      .then((response: any) => {
        const meeting_url = response.data.meeting_url;
        setMeetingLink(meeting_url);
        setWhatsAppLink(whatsappLink + meeting_url);
        setSMSLink(smsLink + meeting_url);
        SetMailLink(mailLink + meeting_url);
      })
      .catch(err => {
        throw err;
      });
  }, []);

  return (
    <div>
      <Dialog
        disableBackdropClick
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={showModal}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle id="customized-dialog-title" className={classes.title}>
          <Typography variant="h6" component={'div'}>
            Invite People to this call
          </Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText> Meeting link </DialogContentText>
          <FormControl fullWidth variant="filled">
            <OutlinedInput
              readOnly
              id="outlined-adornment-link"
              value={meetingLink}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={handleClick} edge="end">
                    <FileCopyIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              autoHideDuration={5000}
              onClose={handleSnapBarClose}
              message="Copied to Clipboard"
            />
          </FormControl>
        </DialogContent>

        <DialogContent className={classes.content}>
          <DialogContentText>Share via</DialogContentText>
          {customer.customer_contact_no && (
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={classes.anchorButton}>
              <Button
                style={{ backgroundColor: '#25D366' }}
                className={classes.iconButton}
                variant="contained"
                startIcon={<WhatsAppIcon />}
              >
                Whatsapp
              </Button>
            </a>
          )}
          <a href={mailLink} target="_blank" rel="noopener noreferrer" className={classes.anchorButton}>
            <Button
              style={{ backgroundColor: '#ECB22E' }}
              className={classes.iconButton}
              variant="contained"
              startIcon={<EmailIcon />}
            >
              Mail
            </Button>
          </a>
          {customer.customer_contact_no && (
            <a href={smsLink} target="_blank" rel="noopener noreferrer" className={classes.anchorButton}>
              <Button
                style={{ backgroundColor: '#00A4EF' }}
                className={classes.iconButton}
                variant="contained"
                startIcon={<SmsIcon />}
              >
                SMS
              </Button>
            </a>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
